import { Check, Monitor, Smartphone, Tablet } from 'lucide-react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { Skeleton } from 'ui';
import Button from 'ui/components/Button';
import DropdownMenu from 'ui/components/Dropdown';
import { getDisplayMode, getIsBottomBarLoading, setDisplayMode } from '../../../store/uiSlice';

// const lockTitle = "Responsive Collaboration"
// const lockDescription = "Catch design issues on mobile, tablet, and desktop before your clients see them. Instantly switch views and leave precise feedback that keeps projects moving."
// const lockModalImgSetting = 'https://wpfeedback-image.s3.us-east-2.amazonaws.com/images/integration-lock-images/lock-user-image.jpg'

export const DeviceMenu = () => {
  const { t } = useTranslation();
  const displayMode = useSelector(getDisplayMode);
  // const user = useSelector(getUser);
  const [selectedDevice, setSelectedDevice] = useState<
    'desktop' | 'tablet' | 'mobile'
  >('desktop');
  const dispatch = useDispatch();
  // const locked = !user?.raw?.plan?.approve_design_enabled;

  const handleDevice = (device: 'desktop' | 'tablet' | 'mobile') => {
    // if (locked) {
    //   dispatch(setShowLockFeature({
    //     showLockFeature: true,
    //     lockTitle: lockTitle,
    //     lockParagraph: lockDescription,
    //     lockImg: lockModalImgSetting,
    //     rank: 2,
    //   }));
    //   return;
    // }
    setSelectedDevice(device);
    dispatch(setDisplayMode(device));
  };

  const isBottomBarLoading = useSelector(getIsBottomBarLoading);

  const iconSize = 18;

  const getDeviceIcon = () => {
    switch (selectedDevice) {
      case 'desktop':
        return <Monitor size={iconSize} />;
      case 'tablet':
        return <Tablet size={iconSize} />;
      case 'mobile':
        return <Smartphone size={iconSize} />;
      default:
        return null;
    }
  };

  return (
    <>
      {isBottomBarLoading ? (
        <Skeleton className="h-9 w-9 rounded-md " />
      ) : (
        <>
          <DropdownMenu modal={false}>
            <DropdownMenu.Trigger
              className="rounded-lg focus:outline-none focus:ring-1 hidden md:flex"
              asChild
            >
              <Button
                variant="outline"
                size="icon"
                leftIcon={getDeviceIcon()}
                tooltip={t('bottom_bar.device_menu_tooltip', 'Preview your design on various screen sizes')}
                tooltipSide="top"
                className=''
              ></Button>
            </DropdownMenu.Trigger>
            <DropdownMenu.Content className="z-10" portal={false}>
              <DropdownMenu.Item
                onClick={() => handleDevice('desktop')}
                onTouchEnd={() => handleDevice('desktop')}
                className={displayMode === 'desktop' ? 'bg-tertiary/10' : ''}
              >
                <Monitor size={iconSize} />
                {t('bottom_bar.device_menu_desktop', 'Desktop')}
                {selectedDevice === 'desktop' && <Check size={18} className='ml-auto' />}
              </DropdownMenu.Item>
              <DropdownMenu.Item
                onClick={() => handleDevice('tablet')}
                onTouchEnd={() => handleDevice('tablet')}
                className={displayMode === 'tablet' ? 'bg-tertiary/10' : ''}
              >
                <Tablet size={iconSize} />
                {t('bottom_bar.device_menu_tablet', 'Tablet')}
                {selectedDevice === 'tablet' && <Check size={18} className='ml-auto' />}
              </DropdownMenu.Item>
              <DropdownMenu.Item
                onClick={() => handleDevice('mobile')}
                onTouchEnd={() => handleDevice('mobile')}
                className={displayMode === 'mobile' ? 'bg-tertiary/10' : ''}
              >
                <Smartphone size={iconSize} />
                {t('bottom_bar.device_menu_mobile', 'Mobile')}
                {selectedDevice === 'mobile' && <Check size={18} className='ml-auto' />}
              </DropdownMenu.Item>
            </DropdownMenu.Content>
          </DropdownMenu>
        </>
      )}
    </>
  );
};
